import { render, staticRenderFns } from "./CodeSentModal.vue?vue&type=template&id=2c0ef882"
import script from "./CodeSentModal.vue?vue&type=script&lang=js"
export * from "./CodeSentModal.vue?vue&type=script&lang=js"
import style0 from "./CodeSentModal.vue?vue&type=style&index=0&id=2c0ef882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports